import { render, staticRenderFns } from "./deviceChildren.vue?vue&type=template&id=8a65c4d4&"
import script from "./deviceChildren.vue?vue&type=script&lang=js&"
export * from "./deviceChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports